import React, {Component} from 'react'
import {NavLink} from 'react-router-dom'

import Logo from './Logo'
import {TimelineMax, Expo} from 'gsap'


// const Nav = () => {
class Nav extends Component {

    componentDidMount() {

        // Setting Objects
        const navLink = document.getElementsByClassName('nav-link')

        let tl = new TimelineMax()

        // setter
        tl.set(navLink, {opacity: 0, x:'+=50'})

        // Animation
        tl.staggerTo(navLink, 3,
            {
                opacity: 1,
                x:0,
                ease: Expo.easeOut}, 0.2);
    }


    render() {
        return (
            <header>
                <NavLink activeClassName='active' exact to="/">
                    <Logo />
                </NavLink>

                <ul className="nav-holder">

                    <li className="nav-link">
                        <NavLink activeClassName='active' exact to="/about">About Us</NavLink>
                    </li>
                    <li className="nav-link">
                        <NavLink activeClassName='active' exact to="/services">Services</NavLink>
                    </li>
                    <li className="nav-link">
                        <NavLink activeClassName='active' exact to="/contact">Contact</NavLink>
                    </li>

                </ul>
            </header>
        )
    }
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/common/Nav/Nav.js